import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRewind"><Path d="M19.9987 20V4L11.9987 10V4L1.33203 12L11.9987 20V14L19.9987 20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRewind;
